import React from "react";
import { motion } from "framer-motion";
import { DESTINATIONS } from "@/data/destinations";

// Handpicked bento cards for the top of the catalog
const featuredIndexes = [40, 3, 4, 21, 23, 8]; // Maldives, Indonesia, Greece, Italy, Canada, Australia

const spanClasses = [
  "md:col-span-7 md:row-span-2 aspect-[16/12]",
  "md:col-span-5 aspect-[4/5]",
  "md:col-span-5 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
];

export const Gallery = () => {
  return (
    <section
      id="catalog"
      data-testid="catalog-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.32em] text-aio-soft mb-4">
              The Catalog
            </p>
            <h2 className="font-display text-5xl sm:text-6xl leading-[1.02] tracking-tighter text-aio-ink">
              A private map of the
              <br />
              <span className="italic">world&apos;s finest</span> stays.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-8 flex md:items-end">
            <p className="text-aio-soft leading-relaxed text-base sm:text-lg">
              Below is a curated selection from our {DESTINATIONS.length}-country
              catalog. The full 130+ destination list is included in the
              downloadable brochure, delivered upon request.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {featuredIndexes.map((idx, i) => {
            const d = DESTINATIONS[idx];
            return (
              <motion.figure
                key={d.country}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.08 }}
                className={`relative group overflow-hidden bg-aio-surface ${spanClasses[i]}`}
                data-testid={`gallery-card-${d.country.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <img
                  src={d.image}
                  alt={d.country}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                <figcaption className="absolute bottom-0 inset-x-0 p-6 sm:p-7 text-white flex items-end justify-between">
                  <div>
                    <p className="text-[10px] uppercase tracking-[0.32em] text-white/70 mb-2">
                      {d.country}
                    </p>
                    <p className="font-display text-2xl sm:text-3xl leading-tight">
                      {d.spots[0]}
                    </p>
                  </div>
                  <span className="text-xs tracking-[0.22em] uppercase text-white/75">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </figcaption>
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};
